module.exports = __webpack_public_path__ + "img/my-member-unselect.7f89d48f.svg";